import React from 'react';
import styled from 'styled-components';
import { format } from 'date-fns';

import Link from '@dashboard/components/Link';
import Circle from './Circle';
import checkIsConnectedToStripe from '@dashboard/services/seller/checkIsConnectedToStripe';
import BottomScrollListener from '@dashboard/components/BottomScrollListener';
import Table from './Table';
import { getRenewalStatus } from '../scenes/Merchant';
import Lozenge from '@dashboard/components/Lozenge';
import { upperFirst } from 'lodash';

const TableWrapper = styled.div`
  margin-right: 1em;
`;

const UsersTable = ({ data = [], onSort, sortBy, sortDirection, getNext }) => {
  const headCells = [
    {
      label: 'Store',
      sortBy: 'displayName',
    },
    {
      label: 'Email',
      sortBy: 'email',
    },
    {
      label: 'Store focus',
      sortBy: 'industry',
    },
    {
      label: 'Plan',
      sortBy: 'seller.plan.handle',
    },
    {
      label: 'Status',
      sortBy: 'seller.subscriptionStatus',
    },
    {
      label: 'Connected',
    },
    {
      label: 'Subscribed',
    },
    {
      label: 'Checkouts',
    },
    {
      label: 'Sessions',
    },
    {
      label: 'Team members',
      sortBy: 'seller.amountOfUsers',
    },
    {
      label: 'Signed up at',
      sortBy: 'createdAt',
    },
    {
      label: 'Last active at',
      sortBy: 'lastActivity',
    },
  ];

  return (
    <TableWrapper>
      <Table.Table>
        <Table.Head>
          {headCells.map(headCell => (
            <Table.Th
              onSort={onSort}
              sortKey={headCell.sortBy}
              key={headCell.label}
              sortBy={sortBy}
              sortDirection={sortDirection}
            >
              {headCell.label}
            </Table.Th>
          ))}
        </Table.Head>

        <BottomScrollListener as="tbody" onBottom={getNext}>
          {data.pages?.map(page =>
            page.data.map(user => {
              return (
                <Table.Row key={user._id}>
                  <Table.Td className="relative !max-w-xs">
                    <Link to={`/admin/merchants/${user.seller._id}`}>
                      {user.seller.displayName || user.seller.name || 'N/A'}
                    </Link>

                    {user.seller.disabled && (
                      <Lozenge className="ml-2 absolute right-0 mt-0.5">Disabled</Lozenge>
                    )}
                  </Table.Td>
                  <Table.Td className="!max-w-xs">
                    <Link to={`/admin/merchants/${user.seller._id}`}>{user.email}</Link>
                  </Table.Td>
                  <Table.Td>
                    <div>
                      {user.seller.industry
                        ? upperFirst(user.seller.industry.replace(/-/g, ' '))
                        : 'N/A'}
                    </div>
                  </Table.Td>
                  <Table.Td>
                    <div>
                      {user.seller?.plan?.title}
                      {user.seller?.plan?.billingPeriod && (
                        <span> - {user.seller?.plan?.billingPeriod}</span>
                      )}
                    </div>
                  </Table.Td>
                  <Table.Td>
                    <div>{getRenewalStatus(user.seller, true)}</div>
                  </Table.Td>
                  <Table.Td>
                    <div>
                      <Circle color={checkIsConnectedToStripe(user.seller) ? 'green' : 'red'} />
                    </div>
                  </Table.Td>
                  <Table.Td>
                    <div>
                      <Circle color={user.seller.stripeSubscriptionId ? 'green' : 'red'} />
                    </div>
                  </Table.Td>
                  <Table.Td>
                    <div>{user.pages}</div>
                  </Table.Td>
                  <Table.Td>
                    <div>{user.sessionCount || 1}</div>
                  </Table.Td>
                  <Table.Td>
                    <div>{user.seller.amountOfUsers}</div>
                  </Table.Td>
                  <Table.Td>
                    <div>{format(new Date(user.createdAt), 'd MMM, yyyy, HH:mm')}</div>
                  </Table.Td>
                  <Table.Td>
                    <div>{format(new Date(user.lastActivity), 'd MMM, yyyy, HH:mm')}</div>
                  </Table.Td>
                </Table.Row>
              );
            }),
          )}
        </BottomScrollListener>
      </Table.Table>
    </TableWrapper>
  );
};

export default UsersTable;
